import Vue from 'vue';
import Component from 'vue-class-component';
import EdCourseTemplateSection from '@/course-templates/components/ed-course-template-section/ed-course-template-section.component.vue';
import { Status } from '@/models/status.model';
import { CourseTemplate } from '@/course-templates/models/course-template.model';
import { TEMPLATE_SCOPE } from '@/course-templates/values/course-templates.values';

@Component({
  components: {
    EdCourseTemplateSection
  }
})
export default class TemplatesView extends Vue {

  public statusPublic: Status = new Status(); 
  public moreStatusPublic: Status = new Status(); 
  public statusPrivate: Status = new Status(); 
  public moreStatusPrivate: Status = new Status(); 
  public statusMyTemplates: Status = new Status(); 
  public moreStatusMyTemplates: Status = new Status(); 

  get publicCourseTemplates(): CourseTemplate[] {
    return this.$store.state.CourseTemplateStore.publicCourseTemplates.content;
  }

  get privateCourseTemplates(): CourseTemplate[] {
    return this.$store.state.CourseTemplateStore.privateCourseTemplates.content;
  }

  get myCourseTemplates() {
    return this.$store.state.CourseTemplateStore.myCourseTemplates.content;
  }

  get canLoadMorePublic() {
    return this.$store.state.CourseTemplateStore.publicCourseTemplates.more;
  }

  get canLoadMorePrivate() {
    return this.$store.state.CourseTemplateStore.privateCourseTemplates.more;
  }

  get canLoadMoreMyTemplates() {
    return this.$store.state.CourseTemplateStore.myCourseTemplates.more;
  }

  get firstMyContentTemplate() {
    return this.$store.state.CourseTemplateStore.myCourseTemplatesFirstTime;
  }

  get firstPublicTemplate() {
    return this.$store.state.CourseTemplateStore.publicContentTemplatesFirstTime;
  }

  get firstPrivateTemplate() {
    return this.$store.state.CourseTemplateStore.privateContentTemplatesFirstTime;
  }

  async getPublicCourseTemplates(status: Status, loadAgain: boolean) {
    try {
      status.setLoading();
      if(loadAgain || !this.firstPublicTemplate && (!this.publicCourseTemplates || this.publicCourseTemplates.length <= 0)) {
        this.$CourseTemplates.Store.setFirstTimeContentTemplate(TEMPLATE_SCOPE.PUBLIC, true);
        await this.$CourseTemplates.Store.getCourseTemplates(TEMPLATE_SCOPE.PUBLIC);
      }
      status.setLoad();
    } catch(err) {
      status.setError();
    }
  }

  async getPrivateCourseTemplates(status: Status, loadAgain: boolean) {
    try {
      status.setLoading();
      if(loadAgain || !this.firstPrivateTemplate && (!this.privateCourseTemplates || this.privateCourseTemplates.length <= 0)) {
        this.$CourseTemplates.Store.setFirstTimeContentTemplate(TEMPLATE_SCOPE.ORGANIZATION, true);
        await this.$CourseTemplates.Store.getCourseTemplates(TEMPLATE_SCOPE.ORGANIZATION);
      }
      status.setLoad();
    } catch(err) {
      status.setError();
    }
  }

  async getMyCourseTemplates(status: Status, loadAgain: boolean) {
    try {
      status.setLoading();
      if(loadAgain || !this.firstMyContentTemplate && (!this.myCourseTemplates || this.myCourseTemplates.length <= 0)) {
        this.$CourseTemplates.Store.setFirstTimeContentTemplate(TEMPLATE_SCOPE.OWNER, true);
        await this.$CourseTemplates.Store.getMyCourseTemplates(TEMPLATE_SCOPE.OWNER);
      }
      status.setLoad();
    } catch(err) {
      status.setError();
    }
  }

  getMorePrivateCourseTemplates() {
    this.getPrivateCourseTemplates(this.moreStatusPrivate, true);
  }

  getMorePublicCourseTemplates() {
    this.getPublicCourseTemplates(this.moreStatusPublic, true);
  }

  getMoreMyCourseTemplates() {
    this.getMyCourseTemplates(this.moreStatusMyTemplates, true);
  }

  created() {
    this.getPublicCourseTemplates(this.statusPublic, false);
    this.getPrivateCourseTemplates(this.statusPrivate, false);
    this.getMyCourseTemplates(this.statusMyTemplates, false);
  }

}